import React, { useState, useEffect, useRef } from 'react';
import SideMenu from '../../../Components/SideMenu';
import Header from '../../../Components/Header';
import Loading from '../../../Components/LoaderScreen';
import Alert from '../../../Components/Alert';
import Toast from '../../../Components/Toast';
import Modal from '../../../Components/Modal';
import Input from '../../../Components/Input';
import ApiService from '../../../Utils/services';
import Funcoes from '../../../Utils/functions';
import { validateCPF, validateEmail, formatCPF, formatPhone } from '../../../Utils/validations';
import { dataBrMask } from '../../../Utils/mask';
import NoResults from '../../../Components/NoResults';
import Pagination from '../../../Components/Pagination';
import RedirectScreen from '../../../Components/RedirectScreen';
import './PaymentLinks.css'; // Importação do CSS para os estilos responsivos
import iconLixeira from '../../../resources/img/icon-lixeira.svg';
import iconVisualizar from '../../../resources/img/icon-visualizar.svg';
import iconCopy from '../../../resources/img/icon-copy.svg';
import iconExport from '../../../resources/img/icon-export.svg';
import iconTableVisualizar from '../../../resources/img/icon-table-visualizar.svg';

// Estilos definidos como objetos JavaScript para uso inline
const styles = {
    statusBadge: {
        display: 'inline-block',
        padding: '3px 8px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    statusPaid: {
        backgroundColor: '#d4edda',
        color: '#155724'
    },
    statusPending: {
        backgroundColor: '#fff3cd',
        color: '#856404'
    },
    statusCanceled: {
        backgroundColor: '#e2e3e5',
        color: '#383d41'
    },
    statusRefunded: {
        backgroundColor: '#f8d7da',
        color: '#721c24'
    },
    statusNotAuthorized: {
        backgroundColor: '#f8d7da',
        color: '#721c24'
    },
    statusProcessing: {
        backgroundColor: '#cce5ff',
        color: '#004085'
    },
    statusUnknown: {
        backgroundColor: '#e2e3e5',
        color: '#383d41'
    },
    btnSm: {
        fontSize: '12px',
        padding: '4px 8px',
        borderRadius: '4px',
        backgroundColor: '#4f5f9e',
        color: 'white',
        cursor: 'pointer',
        border: 'none'
    }
};

export default function PaymentLinks() {
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [alertType, setAlertType] = useState(2);
    const [toastShow, setToastShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('success');
    const [links, setLinks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [showLinkModal, setShowLinkModal] = useState(false);
    
    // Estados para redirecionamento
    const [redirect, setRedirect] = useState(false);
    const [path, setPath] = useState('');
    const [propsToPath, setPropsToPath] = useState({});
    
    // Estados para filtros
    const [showMoreFilters, setShowMoreFilters] = useState(false);
    const [filtroStatus, setFiltroStatus] = useState('');
    const [filtroDocumento, setFiltroDocumento] = useState('');
    const [filtroNome, setFiltroNome] = useState('');
    const [filtroDataInicio, setFiltroDataInicio] = useState('');
    const [filtroDataFim, setFiltroDataFim] = useState('');
    const [filtroPagamentoInicio, setFiltroPagamentoInicio] = useState('');
    const [filtroPagamentoFim, setFiltroPagamentoFim] = useState('');
    const [paymentLink, setPaymentLink] = useState('');
    const [editingLink, setEditingLink] = useState(null);
    const [descricao, setDescricao] = useState('');
    const [valor, setValor] = useState(0);
    const [maxparcsemjuros, setMaxParcSemJuros] = useState(12);
    const [datavalidade, setDataValidade] = useState(new Date().toISOString().split('T')[0]);
    const [clinome, setCliNome] = useState('');
    const [clidocumento, setCliDocumento] = useState('');
    const [cliemail, setCliEmail] = useState('');
    const [clicelular, setCliCelular] = useState('');
    const [showTooltip, setShowTooltip] = useState(false);
    const valorInputRef = useRef(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Verificar se é dispositivo móvel
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        
        return () => {
            window.removeEventListener('resize', checkIfMobile);
        };
    }, []);

    useEffect(() => {
        loadLinks(1);
    }, []);
    
    // Função para visualizar detalhes da transação
    const visualizarDetalhes = (tscId) => {
        setPropsToPath({id: tscId});
        setPath("/transacoes/detalhes");
        setRedirect(true);
    };

    useEffect(() => {
        if (showModal) {
            // Mostra o tooltip quando o modal abre
            setShowTooltip(true);
            
            // Remove o tooltip após 3 segundos
            const timer = setTimeout(() => {
                setShowTooltip(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [showModal]);

    useEffect(() => {
        if (valorInputRef.current) {
            valorInputRef.current.blur();
        }
    }, [valor]);

    const getStatusText = (status) => {
        switch (status) {
            case 0:
            case null:
                return 'Pendente';
            case 1:
                return 'Pago';
            case 2:
                return 'Cancelado';
            case 3:
                return 'Estornada';
            case 4:
                return 'Não Autorizada';
            case 5:
                return 'Em processamento';
            default:
                return 'Desconhecido';
        }
    };
    
    const getStatusStyle = (status) => {
        switch (status) {
            case 0:
            case null:
                return styles.statusPending;
            case 1:
                return styles.statusPaid;
            case 2:
                return styles.statusCanceled;
            case 3:
                return styles.statusRefunded;
            case 4:
                return styles.statusNotAuthorized;
            case 5:
                return styles.statusProcessing;
            default:
                return styles.statusUnknown;
        }
    };

    const loadLinks = (page) => {
        setLoading(true);
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        
        ApiService.get(`payment-links?page=${page}`, userData.token)
            .then(result => {
                // Ordenar explicitamente os links por data de criação (lnk_dthrgerado) em ordem crescente
                const sortedLinks = [...result.data.data].sort((a, b) => {
                    // Se a data de criação não existir, usamos o ID como fallback
                    const dateA = a.lnk_dthrgerado || a.lnk_id;
                    const dateB = b.lnk_dthrgerado || b.lnk_id;
                    return dateB.localeCompare(dateA); // Ordem DECRESCENTE (novos primeiro)
                });
                
                setLinks(sortedLinks);
                setTotalPages(result.data.last_page);
                setCurrentPage(result.data.current_page);
                setLoading(false);
            })
            .catch(err => {
                const result = ApiService.handleErros(err.response);
                setLoading(false);
                setAlertText(result.response);
                setTimeout(() => {
                    setAlert(true);
                }, 300);
            });
    };
    
    // Função para filtrar os links de pagamento
    const handleFilter = () => {
        setLoading(true);
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        
        let url = `payment-links?page=1`;
        
        // Adicionar filtros à URL
        if (filtroStatus) url += `&status=${filtroStatus}`;
        if (filtroDocumento) url += `&documento=${filtroDocumento}`;
        if (filtroNome) url += `&nome=${filtroNome}`;

        // Filtros de data de pagamento
        if (filtroPagamentoInicio && filtroPagamentoFim) {
            url += `&pagamento_inicio=${Funcoes.data2Americano(filtroPagamentoInicio)}`;
            url += `&pagamento_fim=${Funcoes.data2Americano(filtroPagamentoFim)}`;
        }
        
        ApiService.get(url, userData.token)
            .then(result => {
                const sortedLinks = [...result.data.data].sort((a, b) => {
                    const dateA = a.lnk_dthrgerado || a.lnk_id;
                    const dateB = b.lnk_dthrgerado || b.lnk_id;
                    return dateB.localeCompare(dateA);
                });
                
                setLinks(sortedLinks);
                setTotalPages(result.data.last_page);
                setCurrentPage(1);
                setLoading(false);
            })
            .catch(err => {
                const result = ApiService.handleErros(err.response);
                setLoading(false);
                setAlertText(result.response);
                setTimeout(() => {
                    setAlert(true);
                }, 300);
            });
    };

    const handleCreate = () => {
        setEditingLink(null);
        clearForm();
        setShowModal(true);
    };

    const handleEdit = (link) => {
        setEditingLink(link);
        setDescricao(link.lnk_descricao);
        setValor(link.lnk_valor);
        setMaxParcSemJuros(link.lnk_maxparcsemjuros);
        setDataValidade(link.lnk_datavalidade.split(' ')[0]);
        setCliNome(link.lnk_clinome);
        setCliDocumento(link.lnk_clidocumento);
        setCliEmail(link.lnk_cliemail);
        setCliCelular(link.lnk_clicelular);
        setShowModal(true);
    };

    // Função para exportar links de pagamento como arquivo XLSX
    const exportarLinks = () => {
        setLoading(true);
        
        // Construir a URL com os parâmetros de exportação
        var url = 'payment-links?exportar=true';
        
        // Adicionar filtros à URL de exportação
        if (filtroStatus) url += `&lnk_status=${filtroStatus}`;
        if (filtroDocumento) url += `&lnk_clidocumento=${filtroDocumento}`;
        if (filtroNome) url += `&lnk_clinome=${filtroNome}`;
        
        // Filtros de data de geração
        if (filtroDataInicio && filtroDataFim) {
            url += `&data_inicio=${Funcoes.data2Americano(filtroDataInicio)}`;
            url += `&data_fim=${Funcoes.data2Americano(filtroDataFim)}`;
        }
        
        // Filtros de data de pagamento
        if (filtroPagamentoInicio && filtroPagamentoFim) {
            url += `&pagamento_inicio=${Funcoes.data2Americano(filtroPagamentoInicio)}`;
            url += `&pagamento_fim=${Funcoes.data2Americano(filtroPagamentoFim)}`;
        }
        
        // Usar a mesma função de URL e mesma configuração do XMLHttpRequest
        var urlBase = ApiService.ExossCardApiUrl();
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        const token = userData.token;
        
        console.log('URL de exportação:', urlBase + url);
        
        const xhr = new XMLHttpRequest();
        xhr.open("GET", urlBase + url);
        xhr.setRequestHeader("Content-Type", "application/vnd.ms-excel");
        xhr.setRequestHeader("Authorization", "Bearer " + token);
        xhr.responseType = "blob";
        
        xhr.onload = () => {
            var blob = new Blob([xhr.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'links_pagamento.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false);
        };
        
        xhr.onerror = () => {
            console.error('Erro de rede ao exportar links de pagamento');
            setAlertText('Erro de conexão ao tentar exportar');
            setTimeout(() => setAlert(true), 300);
            setLoading(false);
        };
        
        xhr.send();
    };

    // Função para copiar o link de pagamento
    const handleCopyLink = (id) => {
        const linkCheckout = process.env.REACT_APP_LINK_CHECKOUT || 'https://checkout.exoss.com.br';
        const linkCompleto = `${linkCheckout}/payment/${id}`;
        
        // Copiar para a área de transferência
        navigator.clipboard.writeText(linkCompleto)
            .then(() => {
                setToastMessage('Link copiado para a área de transferência!');
                setToastType('success');
                setToastShow(true);
            })
            .catch(err => {
                console.error('Erro ao copiar link:', err);
                setAlertText('Erro ao copiar link. Tente novamente.');
                setAlertType(0);
                setTimeout(() => {
                    setAlert(true);
                }, 300);
            });
    };
    
    const handleDelete = (id) => {
        if (window.confirm('Tem certeza que deseja excluir este link de pagamento?')) {
            setLoading(true);
            const userData = JSON.parse(sessionStorage.getItem("userData"));
            
            ApiService.customRequest(`payment-links/${id}`, {}, 'DELETE', userData.token)
                .then(() => {
                    setAlertType(1);
                    setAlertText('Link de pagamento excluído com sucesso!');
                    setTimeout(() => {
                        setAlert(true);
                    }, 300);
                    loadLinks(currentPage);
                })
                .catch(err => {
                    const result = ApiService.handleErros(err.response);
                    setLoading(false);
                    setAlertText(result.response);
                    setTimeout(() => {
                        setAlert(true);
                    }, 300);
                });
        }
    };

    const clearForm = () => {
        setDescricao('');
        setValor(0);
        setMaxParcSemJuros(12);
        setDataValidade(new Date().toISOString().split('T')[0]);
        setCliNome('');
        setCliDocumento('');
        setCliEmail('');
        setCliCelular('');
    };

    const handleSubmit = () => {
        // Validar campos obrigatórios
        if (!descricao || !valor || !datavalidade || !maxparcsemjuros) {
            setAlertType(2);
            setAlertText('Preencha todos os campos obrigatórios!');
            setTimeout(() => {
                setAlert(true);
            }, 300);
            return;
        }

        if (valor <= 0) {
            setAlertType(2);
            setAlertText('O valor deve ser maior que zero!');
            setTimeout(() => {
                setAlert(true);
            }, 300);
            return;
        }

        setLoading(true);
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        const data = {
            tipoprodserv: 1, // Tipo produto como default
            descricao,
            valor: parseFloat(valor),
            maxparcsemjuros,
            datavalidade,
            clinome,
            clidocumento: clidocumento ? clidocumento.replace(/\D/g, '') : '', // Remove máscara antes de enviar (se existir)
            cliemail,
            clicelular: clicelular ? clicelular.replace(/\D/g, '') : '' // Remove máscara antes de enviar (se existir)
        };

        const method = editingLink ? 'PUT' : 'POST';
        const url = editingLink ? `payment-links/${editingLink.lnk_id}` : 'payment-links';

        ApiService.customRequest(url, data, method, userData.token)
            .then((response) => {
            
                
                // Primeiro fecha o modal de edição
                setShowModal(false);
                
                // Verifica se o link está em diferentes lugares possíveis na resposta
                const link = response.data?.link || response.data?.data?.link || response.data?.lnk_link;
                
                if (link) {
                   ;
                    setPaymentLink(link);
                    // Mostra o modal do link depois de um pequeno delay
                    setTimeout(() => {
                        setShowLinkModal(true);
                    }, 500);
                } else {
                    console.log('No link found in response');
                }
                
                // Mostra a mensagem de sucesso como toast em vez de alerta
                setToastMessage(`Link de pagamento ${editingLink ? 'atualizado' : 'criado'} com sucesso!`);
                setToastType('success');
                setToastShow(true);
                
                loadLinks(currentPage);
            })
            .catch(err => {
                const result = ApiService.handleErros(err.response);
                setLoading(false);
                setAlertText(result.response);
                setTimeout(() => {
                    setAlert(true);
                }, 300);
            });
    };

    const handleValorChange = (e, masked, floatValue) => {
        setValor(floatValue);
    };

    return (
        <>
            <RedirectScreen redirect={redirect} path={path} props={propsToPath} />
            <Loading show={loading} />
            <Alert show={alert} texto={alertText} tipo={alertType} action={() => setAlert(false)} />
            {toastShow && <Toast message={toastMessage} type={toastType} onClose={() => setToastShow(false)} />}
            
            <Modal show={showModal} footer={
                <>
                    <button 
                        className="btn secondary" 
                        onClick={() => setShowModal(false)}
                    >
                        Cancelar
                    </button>
                    <button 
                        className="btn primary"
                        onClick={handleSubmit}
                    >
                        {editingLink ? 'Atualizar' : 'Criar'}
                    </button>
                </>
            } title={editingLink ? 'Editar Link de Pagamento' : 'Novo Link de Pagamento'} onClose={() => setShowModal(false)}>
                    <div className="form-group">
                        <label>Descrição *</label>
                        <Input 
                            type="text" 
                            className="form-control"
                            value={descricao}
                            onChange={e => setDescricao(e.target.value)}
                            placeholder="Digite a descrição do produto"
                        />
                    </div>

                    <div className="form-group">
                        <label>Valor *</label>
                        <Input 
                            type="money"
                            className="form-control"
                            value={valor}
                            onChangeEvent={(e, masked, floatValue) => setValor(floatValue)}
                            autoComplete="off"
                            inputMode="decimal"
                            ref={valorInputRef}
                        />
                    </div>

                    <div className="form-group">
                        <label>Máximo de Parcelas sem Juros *</label>
                        <select 
                            className="form-control"
                            value={maxparcsemjuros}
                            onChange={e => setMaxParcSemJuros(parseInt(e.target.value))}
                        >
                            <option value={1}>1x</option>
                            <option value={2}>2x</option>
                            <option value={3}>3x</option>
                            <option value={4}>4x</option>
                            <option value={5}>5x</option>
                            <option value={6}>6x</option>
                            <option value={7}>7x</option>
                            <option value={8}>8x</option>
                            <option value={9}>9x</option>
                            <option value={10}>10x</option>
                            <option value={11}>11x</option>
                            <option value={12}>12x</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Data de Validade *</label>
                        <Input 
                            type="date" 
                            className="form-control"
                            value={datavalidade}
                            onChange={e => setDataValidade(e.target.value)}
                            min={new Date().toISOString().split('T')[0]}
                        />
                    </div>

                    <div className="form-group">
                        <label>Nome do Cliente</label>
                        <Input 
                            type="text" 
                            className="form-control"
                            value={clinome || ''}
                            onChange={e => setCliNome(e.target.value)}
                            placeholder="Nome do cliente (opcional)"
                        />
                    </div>

                    <div className="form-group">
                        <label>Documento do Cliente</label>
                        <Input 
                            type="text" 
                            className="form-control"
                            value={clidocumento || ''}
                            onChange={e => setCliDocumento(e.target.value)}
                            placeholder="CPF/CNPJ do cliente (opcional)"
                        />
                    </div>

                    <div className="form-group">
                        <label>E-mail do Cliente</label>
                        <Input 
                            type="email" 
                            className="form-control"
                            value={cliemail || ''}
                            onChange={e => setCliEmail(e.target.value)}
                            placeholder="E-mail do cliente (opcional)"
                        />
                    </div>

                    <div className="form-group">
                        <label>Celular do Cliente</label>
                        <Input 
                            type="text" 
                            className="form-control"
                            value={clicelular || ''}
                            onChange={e => setCliCelular(formatPhone(e.target.value))}
                            placeholder="Celular do cliente (opcional)"
                        />
                    </div>
            </Modal>

            <Modal show={showLinkModal} title="Link de Pagamento" onClose={() => setShowLinkModal(false)}>
                <div className="modalBody">
                    <div className="form-group">
                        <div style={{ 
                            background: '#f5f5f5', 
                            padding: '15px', 
                            borderRadius: '4px',
                            wordBreak: 'break-all',
                            fontSize: '14px'
                        }}>
                            {paymentLink}
                        </div>
                    </div>
                    <div className="modal-actions">
                        <button 
                            className="btn secondary" 
                            onClick={() => setShowLinkModal(false)}
                        >
                            Fechar
                        </button>
                        <button 
                            className="btn primary"
                            onClick={() => {
                                navigator.clipboard.writeText(paymentLink);
                                const btn = document.createElement('div');
                                btn.innerHTML = 'Link copiado!';
                                btn.style.position = 'fixed';
                                btn.style.top = '20px';
                                btn.style.right = '20px';
                                btn.style.background = '#28a745';
                                btn.style.color = 'white';
                                btn.style.padding = '10px';
                                btn.style.borderRadius = '4px';
                                btn.style.zIndex = '9999';
                                document.body.appendChild(btn);
                                setTimeout(() => document.body.removeChild(btn), 2000);
                            }}
                        >
                            Copiar Link
                        </button>
                    </div>
                </div>
            </Modal>
            <SideMenu menuAtivo={5} />

            <div className="body">
                <Header />

                <div className="dashboard mgDefault">
                    <div className="headerBtn" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <div>
                            <h1>Links de Pagamento</h1>
                        </div>
                        <div>
                            <button className="btn" style={{ marginRight: '10px' }} onClick={exportarLinks}>
                                <img src={iconExport} alt="Exportar" style={{ width: '20px', height: '20px', marginRight: isMobile ? '0' : '5px' }} />
                                {!isMobile && <span>Exportar (.xlsx)</span>}
                            </button>
                            <button className="btn" onClick={handleCreate}>Novo Link</button>
                        </div>
                    </div>
                    
                    <div className="panel" style={{ marginBottom: '20px' }}>
                        <h5 style={{ margin: '15px 0 15px 20px' }}>Filtros</h5>
                        <div style={{ padding: '0 20px 15px' }}>
                            {/* Layout para desktop */}
                            {!isMobile && (
                                <>
                                    {/* Primeira linha: Status, Documento, Nome e botão de mais filtros */}
                                    <div style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                                        <div style={{ flex: '0 0 20%', paddingRight: '15px' }}>
                                            <Input 
                                                type="select" 
                                                label="Status" 
                                                value={filtroStatus}
                                                onChange={e => setFiltroStatus(e.target.value)} 
                                                divStyle={{ width: '100%' }}
                                            >
                                                <option value="">Selecione</option>
                                                <option value="0">Pendente</option>
                                                <option value="1">Pago</option>
                                            </Input>
                                        </div>
                                        
                                        <div style={{ flex: '0 0 25%', paddingRight: '15px' }}>
                                            <Input 
                                                type="text" 
                                                label="CPF/CNPJ" 
                                                value={filtroDocumento} 
                                                onChange={e => setFiltroDocumento(formatCPF(e.target.value))} 
                                                divStyle={{ width: '100%' }}
                                            />
                                        </div>
                                        
                                        <div style={{ flex: '0 0 25%', paddingRight: '15px' }}>
                                            <Input 
                                                type="text" 
                                                label="Nome do Cliente" 
                                                value={filtroNome} 
                                                onChange={e => setFiltroNome(e.target.value)} 
                                                divStyle={{ width: '100%' }}
                                            />
                                        </div>
                                        
                                        <div style={{ flex: '1', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                            <button 
                                                className="btn" 
                                                onClick={() => setShowMoreFilters(!showMoreFilters)}
                                                style={{ 
                                                    height: '38px', 
                                                    backgroundColor: '#f0f0f0', 
                                                    color: '#333',
                                                    border: '1px solid #ccc',
                                                    marginBottom: '10px',
                                                    padding: '0 15px'
                                                }}
                                            >
                                                {showMoreFilters ? 'Menos filtros' : 'Mais filtros'}
                                            </button>
                                        </div>
                                    </div>
                                            
                                    {/* Data de Pagamento */}
                                    <div style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                                        <div style={{ flex: '1', display: 'flex', alignItems: 'flex-end' }}>
                                            <Input 
                                                type="tel" 
                                                label="Data de Pagamento (início)" 
                                                value={filtroPagamentoInicio} 
                                                onChange={e => setFiltroPagamentoInicio(dataBrMask(e.target.value))} 
                                                divStyle={{ flex: 1, marginRight: '5px' }} 
                                            />
                                            <span style={{ margin: '0 5px 10px' }}>à</span>
                                            <Input 
                                                type="tel" 
                                                value={filtroPagamentoFim} 
                                                onChange={e => setFiltroPagamentoFim(dataBrMask(e.target.value))} 
                                                divStyle={{ flex: 1, marginLeft: '5px' }} 
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Botão Filtrar */}
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '5px' }}>
                                        <button 
                                            className="btn" 
                                            onClick={handleFilter}
                                            style={{ 
                                                height: '38px', 
                                                width: '150px', 
                                                backgroundColor: '#4cd964', 
                                                color: 'white',
                                                fontWeight: 'bold',
                                                marginBottom: '10px'
                                            }}
                                        >
                                            FILTRAR
                                        </button>
                                    </div>
                                </>
                            )}

                            {/* Layout para mobile */}
                            {isMobile && (
                                <div style={{ width: '100%' }}>
                                    {/* Status */}
                                    <div style={{ marginBottom: '15px' }}>
                                        <Input 
                                            type="select" 
                                            label="Status" 
                                            value={filtroStatus}
                                            onChange={e => setFiltroStatus(e.target.value)} 
                                            divStyle={{ width: '100%' }}
                                        >
                                            <option value="">Selecione</option>
                                            <option value="0">Pendente</option>
                                            <option value="1">Pago</option>
                                        </Input>
                                    </div>
                                    
                                    {/* CPF/CNPJ */}
                                    <div style={{ marginBottom: '15px' }}>
                                        <Input 
                                            type="text" 
                                            label="CPF/CNPJ" 
                                            value={filtroDocumento} 
                                            onChange={e => setFiltroDocumento(formatCPF(e.target.value))} 
                                            divStyle={{ width: '100%' }}
                                        />
                                    </div>
                                    
                                    {/* Nome */}
                                    <div style={{ marginBottom: '15px' }}>
                                        <Input 
                                            type="text" 
                                            label="Nome do Cliente" 
                                            value={filtroNome} 
                                            onChange={e => setFiltroNome(e.target.value)} 
                                            divStyle={{ width: '100%' }}
                                        />
                                    </div>
        
                                    {/* Filtros adicionais para mobile */}
                                    {showMoreFilters && (
                                        <>
                                            {/* Data de Geração */}
                                            <div style={{ marginBottom: '15px' }}>
                                                <Input 
                                                    type="tel" 
                                                    label="Data de Geração (início)" 
                                                    value={filtroDataInicio} 
                                                    onChange={e => setFiltroDataInicio(dataBrMask(e.target.value))} 
                                                    divStyle={{ width: '100%' }} 
                                                />
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <Input 
                                                    type="tel" 
                                                    label="Data de Geração (fim)" 
                                                    value={filtroDataFim} 
                                                    onChange={e => setFiltroDataFim(dataBrMask(e.target.value))} 
                                                    divStyle={{ width: '100%' }} 
                                                />
                                            </div>
                                            
                                            {/* Data de Pagamento */}
                                            <div style={{ marginBottom: '15px' }}>
                                                <Input 
                                                    type="tel" 
                                                    label="Data de Pagamento (início)" 
                                                    value={filtroPagamentoInicio} 
                                                    onChange={e => setFiltroPagamentoInicio(dataBrMask(e.target.value))} 
                                                    divStyle={{ width: '100%' }} 
                                                />
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <Input 
                                                    type="tel" 
                                                    label="Data de Pagamento (fim)" 
                                                    value={filtroPagamentoFim} 
                                                    onChange={e => setFiltroPagamentoFim(dataBrMask(e.target.value))} 
                                                    divStyle={{ width: '100%' }} 
                                                />
                                            </div>
                                        </>
                                    )}
                                    
                                    {/* Botão Filtrar para mobile */}
                                    <div style={{ marginBottom: '15px' }}>
                                        <button 
                                            className="btn" 
                                            onClick={handleFilter}
                                            style={{ 
                                                width: '100%', 
                                                backgroundColor: '#4cd964', 
                                                color: 'white',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            FILTRAR
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="panel">
                        {/* Exibição de tabela para Desktop */}
                        <div className="table-responsive desktop-only">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Descrição</th>
                                        <th>Valor</th>
                                        <th>Cliente</th>
                                        <th className="mobile-hidden">Validade</th>
                                        <th>Status</th>
                                        <th>Parcelas</th>
                                        <th style={{ minWidth: '180px' }}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {links.length > 0 ? (
                                        links.map(link => (
                                            <tr key={link.lnk_id}>
                                                <td>{link.lnk_id}</td>
                                                <td>{link.lnk_descricao}</td>
                                                <td>R$ {Funcoes.float2Preco(link.lnk_valor)}</td>
                                                <td>{link.lnk_clinome}</td>
                                                <td className="mobile-hidden" data-label="Validade">{Funcoes.geraDataAbreviada(link.lnk_datavalidade.split(' ')[0])}</td>
                                                <td>
                                                    <span style={{...styles.statusBadge, ...getStatusStyle(link.tsc_status)}}>
                                                        {getStatusText(link.tsc_status)}
                                                    </span>
                                                </td>
                                                <td>{link.lnk_parcelas || '1'}x</td>
                                                <td className="actions">
                                                    <button onClick={() => handleEdit(link)} style={styles.btnSm}>
                                                        <img src={iconVisualizar} alt="Editar" style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                    <button onClick={() => handleCopyLink(link.lnk_id)} style={{...styles.btnSm, marginLeft: '5px'}}>
                                                        <img src={iconCopy} alt="Copiar Link" style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                    {link.tsc_id && (
                                                        <button 
                                                            onClick={() => visualizarDetalhes(link.tsc_id)} 
                                                            style={{...styles.btnSm, marginLeft: '5px', backgroundColor: '#17a2b8'}}
                                                            title="Ver detalhes da transação"
                                                        >
                                                            <img src={iconTableVisualizar} alt="Detalhes" style={{ width: '16px', height: '16px' }} />
                                                        </button>
                                                    )}
                                                    <button 
                                                        onClick={() => handleDelete(link.lnk_id)} 
                                                        style={{...styles.btnSm, marginLeft: '5px', backgroundColor: '#dc3545'}}
                                                        title="Excluir link"
                                                    >
                                                        <img src={iconLixeira} alt="Excluir" style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <NoResults />
                                    )}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* Exibição de cards para Mobile */}
                        <div className="mobile-cards-list">
                            {links.length > 0 ? (
                                links.map(link => (
                                    <div key={link.lnk_id} className="mobile-card">
                                        <div className="mobile-card-row">
                                            <strong>ID:</strong>
                                            <span>{link.lnk_id}</span>
                                        </div>
                                        <div className="mobile-card-row">
                                            <strong>Descrição:</strong>
                                            <span>{link.lnk_descricao}</span>
                                        </div>
                                        <div className="mobile-card-row">
                                            <strong>Valor:</strong>
                                            <span>R$ {Funcoes.float2Preco(link.lnk_valor)}</span>
                                        </div>
                                        <div className="mobile-card-row">
                                            <strong>Cliente:</strong>
                                            <span>{link.lnk_clinome}</span>
                                        </div>
                                        <div className="mobile-card-row">
                                            <strong>Validade:</strong>
                                            <span>{Funcoes.geraDataAbreviada(link.lnk_datavalidade.split(' ')[0])}</span>
                                        </div>
                                        <div className="mobile-card-row">
                                            <strong>Status:</strong>
                                            <span style={{...styles.statusBadge, ...getStatusStyle(link.tsc_status)}}>
                                            {getStatusText(link.tsc_status)}
                                            </span>
                                        </div>
                                        <div className="mobile-card-row">
                                            <strong>Parcelas:</strong>
                                            <span>{link.lnk_parcelas || '1'}x</span>
                                        </div>
                                        <div className="mobile-card-actions">
                                            <button className="btn btnIcon" onClick={() => handleEdit(link)}>
                                                <img src={iconVisualizar} alt="Editar" width="18" />
                                            </button>
                                            <button className="btn btnIcon" onClick={() => handleDelete(link.lnk_id)}>
                                                <img src={iconLixeira} alt="Excluir" width="18" />
                                            </button>
                                            <button className="btn btnIcon" onClick={() => {
                                                setPaymentLink(link.link);
                                                setShowLinkModal(true);
                                            }}>
                                                <img src={iconCopy} alt="Copiar Link" width="18" />
                                            </button>
                                            {link.tsc_id && (
                                                <button 
                                                    onClick={() => visualizarDetalhes(link.tsc_id)}
                                                    style={{...styles.btnSm, marginLeft: 5 }}
                                                >
                                                    Ver detalhes
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <NoResults />
                            )}
                        </div>
                        <Pagination 
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => {
                                setCurrentPage(page);
                                loadLinks(page);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
